import React, { Fragment } from 'react'
import {Card,Col,Container,Form,Row, InputGroup} from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { formato_rut, isValidParam } from '../../../common/Formatos'

const Implicado = ({ formik,setPaisImplicadoFinal }) => {
  const data_datos_generales = useSelector((state) => state.casoGeneralReducer)
  const { cfg_form_implicado } = data_datos_generales
  const data_datos_implicado = useSelector((state) => state.implicadoReducer)
  const { datosPantalla } = data_datos_implicado

  return (
    <>
      {/* <Container> */}
      <Card className='mt-1 '>
        <Card.Header
          className='mt-0 mb-0'
          as='h6'
          style={{ backgroundColor: '#D9EDF6', color: '#8578CD' }}
        >
          {cfg_form_implicado
            ? cfg_form_implicado.cfg_form_implicado[
                'gestcasosrecup-editimpl-title-tabimplicado'
              ]
            : null}
        </Card.Header>
        <Container>
          {cfg_form_implicado ? (
            <div>
              <Row>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-rutimpl'
                      ]
                    }
                  </Form.Label>{' '}
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? formato_rut(datosPantalla.datosPantalla[0]['RutImplicado'])
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className=' mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-nomimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? (datosPantalla.datosPantalla[0]['NombreImplicado'])
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-dirimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? (datosPantalla.datosPantalla[0]['DireccionImplicado'])
                        : ""}
                    </Form.Text>
                </Col>

                <Col>
                  <Form.Label
                    className='mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-emailimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? (datosPantalla.datosPantalla[0]['EmailImplicado'])
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-fonoimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisFonoImpl'])
                        ? (datosPantalla.datosPantalla[0]['paisFonoImpl'])+" "+datosPantalla.datosPantalla[0]['FonoImplicado']
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecup-editimpl-movilimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['paisMovilImpl'])
                        ? (datosPantalla.datosPantalla[0]['paisMovilImpl'])+" "+datosPantalla.datosPantalla[0]['MovilImplicado']
                        : ""}
                    </Form.Text>
                </Col>

                <Col>
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {
                      cfg_form_implicado.cfg_form_implicado[
                        'gestcasosrecupeditimpl-comunaimpl'
                      ]
                    }
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? (datosPantalla.datosPantalla[0]['ComunaImplicado'])
                        : ""}
                    </Form.Text>
                </Col>
                <Col>
                  <Form.Label className=' mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                    {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-ciudadimpl']}
                  </Form.Label>
                  <br />
                  <InputGroup className='mb-3 w-75'>
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && datosPantalla.length !== 'undefined'
                        ? (datosPantalla.datosPantalla[0]['CiudadImplicado'])
                        : ""}
                    </Form.Text>
                  </InputGroup>
                </Col>
              </Row>
              <Row>
              <Col>
                  <Form.Label className=' mb-2' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obs'] ? cfg_form_implicado.cfg_form_implicado['gestcasosrecup-editimpl-obs'] : "Observaciones"}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
                      {datosPantalla && isValidParam(datosPantalla.datosPantalla[0]['obsImplicado'])
                        ? (datosPantalla.datosPantalla[0]['obsImplicado'])
                        : ""}
                    </Form.Text>
                </Col>
              </Row>
            </div>
          ) : null}
        </Container>
      </Card>
    </>
  )
}

export default Implicado
